// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__1fjq1","sendOtp":"AuthorizeToLogin_sendOtp__WiCM-"};